<template>
    <div>
      <div class="box_rank your_rank">
        <h3>{{ getTranslations.home_leadeboard_rank }}</h3>
        <div class="prize_user_row">
          <div class="user_img_bg">
            <base-avatar-image :src="userDetails.avatar"></base-avatar-image>
          </div>
          <div class="col_mobile">
            <div class="user_info">
              <p class="name">{{ userDetails.username }}</p>
            </div>
            <div class="rank_and_points">
              <p class="date_txt">{{ getTranslations.home_leadeboard_your_points }} <b>{{ currentUserStats.points }}</b></p>
              <p class="date_txt">{{ getTranslations.home_leadeboard_your_rank }} <b>{{ currentUserStats.rank }}</b></p>
            </div>
          </div>
        </div>
      </div>

      <div class="box_rank your_leader">
        <h3>{{ getTranslations.home_leadeboard_rank_leaderboard }} <span>{{ getTranslations.home_leadeboard_rank_top }} </span></h3>
        <div v-for="(user, index) in filteredLeaderboard"
             :key="index"
             class="prize_user_row"
             @click="user.username !== userDetails.username ? goToUserDetailsPage(user) : null"
        >
          <div class="user_img_bg" :style="(user.username === userDetails.username || user.hasPrivateProfile) ? 'cursor: default': ''">
            <base-avatar-image :src="user.avatar"></base-avatar-image>
          </div>
          <div class="col_mobile">
            <div class="user_info">
              <p class="name" :style="(user.username === userDetails.username || user.hasPrivateProfile) ? 'cursor: default': ''">{{ user.username || '' }}</p>
              <p v-if="user.username === userDetails.username" class="you_txt">{{ getTranslations.home_leadeboard_rank_you }}</p>
            </div>
            <div class="date_box">
              <p class="date_txt">{{ getTranslations.home_leadeboard_rank_leaderboard_points }} </p>
              <p class="date">{{ user.points }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {mapGetters, mapActions, mapState} from 'vuex';
import BaseAvatarImage from '../../common/image/BaseAvatarImage.vue'

export default {
  name: 'leaderboard-rank',
  components: {BaseAvatarImage},
  props: {
    currentPrizeType: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('profile', [
      'getDailyWinnersForLeaderboard',
      'getWeeklyWinnersForLeaderboard',
      'getMonthlyWinnersForLeaderboard',
      'getGrandWinnersForLeaderboard',
      'getFinalWinnersForLeaderboard',
    ]),
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n',[
      'getTranslations',
      'getLocale'
    ]),
    filteredLeaderboard() {
      let leaderboard = [];
      if (this.currentPrizeType === 'DAILY') {
        leaderboard = this.getDailyWinnersForLeaderboard[2] || [];
      } else if (this.currentPrizeType === 'WEEKLY') {
        leaderboard = this.getWeeklyWinnersForLeaderboard[2] || [];
      } else if (this.currentPrizeType === 'MONTHLY') {
        leaderboard = this.getMonthlyWinnersForLeaderboard[2] || [];
      } else if (this.currentPrizeType === 'GRAND') {
        leaderboard = this.getGrandWinnersForLeaderboard[2] || [];
      } else if (this.currentPrizeType === 'FINAL') {
        leaderboard = this.getFinalWinnersForLeaderboard[2] || [];
      }

      return leaderboard.slice(0, 5); // Only take top 5
    },
    currentUserStats() {
      if (!this.userDetails || !this.filteredLeaderboard) return { rank: this.getTranslations.home_leadeboard_rank_leaderboard_pending, points: this.userDetails.totalPointsEarned };

      const foundUser = this.filteredLeaderboard.find(user => user.username === this.userDetails.username);


      return foundUser ? { rank: foundUser.rank, points: foundUser.points } : { rank: this.getTranslations.home_leadeboard_rank_leaderboard_pending, points: this.userDetails.totalPointsEarned };
    }
  },
  watch: {
    // Watch for changes in the currentPrizeType and fetch data
    currentPrizeType(newType) {
      if (newType) {
        this.fetchLeaderboardData(newType);
      }
    },
  },
  methods: {
    ...mapActions('profile', [
      'storePrizesAndWinners',
    ]),
    fetchLeaderboardData(prizeType) {

      const payload = {
        prizeType: prizeType.toUpperCase(),
        language: this.getLocale.toUpperCase(),
      };
      this.storePrizesAndWinners(payload);
    },
    goToRankUserStats() {
      this.$router.push({ name: 'rankUserStats' });
    },
    goToUserDetailsPage ({msisdn, hasPrivateProfile}) {
      if (hasPrivateProfile) { return; }

      localStorage.setItem('rankUserPageInfo', JSON.stringify({id: msisdn, prevPageName: 'prizesAndLeaderBoards'}));
      this.$router.push({name: 'rankUserStats'});
    }
  },
  mounted() {
    if (this.currentPrizeType) {
      this.fetchLeaderboardData(this.currentPrizeType);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/prizesAndLeaderboards/LeaderboardRank.vue